import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ClientData } from '@shared/models/ClientData';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  private readonly http = inject(HttpClient);

  async getClient(
    searchValue: string,
    tenantId: string,
    searchType: string
  ): Promise<ClientData> {
    const params = new HttpParams()
      .set('searchValue', searchValue)
      .set('searchType', searchType);

    return firstValueFrom(
      this.http.get<ClientData>(
        `${environment.API_CUSTOMER}/customers/${tenantId}`,
        { params }
      )
    );
  }

  async createClient(
    clientData: ClientData,
    tenantId: string
  ): Promise<ClientData> {
    return firstValueFrom(
      this.http.post<ClientData>(
        `${environment.API_CUSTOMER}/customers/${tenantId}`,
        clientData
      )
    );
  }
}
